import { ModifiersStyles } from 'react-day-picker';

export const modifiersStyles: ModifiersStyles = {
  lastPeriod: {
    backgroundColor: '#E6F3FF',
    borderRadius: '0',
    borderTop: '2px solid white',
    borderBottom: '2px solid white',
  },
  lastPeriod_start: {
    backgroundColor: '#E6F3FF',
    borderTopLeftRadius: '16px',
    borderBottomLeftRadius: '16px',
    borderTop: '2px solid white',
    borderBottom: '2px solid white',
  },
  lastPeriod_end: {
    backgroundColor: '#E6F3FF',
    borderTopRightRadius: '16px',
    borderBottomRightRadius: '16px',
    borderTop: '2px solid white',
    borderBottom: '2px solid white',
  },
  currentPeriod: {
    backgroundColor: '#E6F3FF',
    borderRadius: '0',
    borderTop: '2px solid white',
    borderBottom: '2px solid white',
  },
  currentPeriod_start: {
    backgroundColor: '#E6F3FF',
    borderTopLeftRadius: '16px',
    borderBottomLeftRadius: '16px',
    borderTop: '2px solid white',
    borderBottom: '2px solid white',
  },
  currentPeriod_end: {
    backgroundColor: '#E6F3FF',
    borderTopRightRadius: '16px',
    borderBottomRightRadius: '16px',
    borderTop: '2px solid white',
    borderBottom: '2px solid white',
  },
  nextPeriod: {
    backgroundColor: '#60A5FA',
    color: 'white',
    borderRadius: '0',
    borderTop: '2px solid white',
    borderBottom: '2px solid white',
  },
  nextPeriod_start: {
    backgroundColor: '#60A5FA',
    color: 'white',
    borderTopLeftRadius: '16px',
    borderBottomLeftRadius: '16px',
    borderTop: '2px solid white',
    borderBottom: '2px solid white',
  },
  nextPeriod_end: {
    backgroundColor: '#60A5FA',
    color: 'white',
    borderTopRightRadius: '16px',
    borderBottomRightRadius: '16px',
    borderTop: '2px solid white',
    borderBottom: '2px solid white',
  },
};
